import EmojiPickerResultOption from './EmojiPickerResultOption';
import { MAX_RESULTS } from '../constants';
import { EMOJI_SUGGESTIONS_LABEL } from '../constants';
import { EmojiPickerViewState } from '../store/schema/EmojiPickerViewState';
import getViewAllIndex from '../utils/getViewAllIndex';
import { observer } from 'mobx-react';
import { Callout, DirectionalHint } from 'office-ui-fabric-react/lib/Callout';
import { getRTL } from 'office-ui-fabric-react/lib/Utilities';
import getEmoji from 'owa-expressions-store/lib/utils/getEmoji';
import loc from 'owa-localize';
import { seeAllLabel } from 'owa-locstrings/lib/strings/seealllabel.locstring.json';
import { PluginUIProps } from 'owa-editor/lib/store/schema/PluginWithUI';
import EmojiPickerPlugin from '../plugin/EmojiPickerPlugin';
import * as React from 'react';

const styles = require('./EmojiPickerResult.scss');

@observer
export default class EmojiPickerResult extends React.Component<
    PluginUIProps<EmojiPickerViewState, EmojiPickerPlugin>,
    {}
> {
    private renderEmojiPanel(viewAllIndex: number) {
        const { viewState } = this.props;
        const { emojiResults } = viewState;

        return (
            <div id={EMOJI_SUGGESTIONS_LABEL} className={styles.emojiResults} role="list">
                {emojiResults.slice(0, MAX_RESULTS).map((emoji, index) => (
                    <EmojiPickerResultOption
                        key={emoji}
                        currentIndex={index}
                        emoji={emoji}
                        {...this.props}
                    />
                ))}
                <EmojiPickerResultOption currentIndex={viewAllIndex} {...this.props} />
            </div>
        );
    }

    private getEmojiShortcode(viewState: EmojiPickerViewState): string {
        let emojiShortcode = '';

        const emoji = getEmoji(viewState.emojiResults[viewState.selectedEmojiIndex]);
        const emojiDescription = emoji?.description;
        if (emojiDescription) {
            emojiShortcode = ':' + emojiDescription.replace(new RegExp(' ', 'g'), '_') + ':';
        }

        return emojiShortcode;
    }

    render() {
        const { viewState } = this.props;
        const { targetPoint, bufferZone } = viewState;
        const viewAllIndex = getViewAllIndex(viewState.emojiResults);

        return targetPoint ? (
            <Callout
                className={styles.callout}
                gapSpace={bufferZone}
                target={targetPoint}
                isBeakVisible={false}
                setInitialFocus={false}
                directionalHint={
                    getRTL() ? DirectionalHint.bottomRightEdge : DirectionalHint.bottomLeftEdge
                }>
                {this.renderEmojiPanel(viewAllIndex)}
                <div className={styles.shortcode}>
                    {viewState.selectedEmojiIndex < viewAllIndex
                        ? this.getEmojiShortcode(viewState)
                        : loc(seeAllLabel)}
                </div>
            </Callout>
        ) : null;
    }
}
